export interface IOption {
	description?: string;
	mail?: string;
	city?: string;
	state?: string;
	zip?: string;
	placeId?: string;
	place_id?: string;
}

// FIXME Move to mock configuration
export const mockOptions = [
	{
		value: 'mock address 1, 123, city, NY, 12345',
		description: 'mock address 1, 123, city, NY, 12345',
		mail: 'mock address 1',
		city: 'city',
		state: 'NY',
		zip: '12345',
	},
	{
		value: 'mock address 2, 123123, other city, TX, 23456',
		description: 'mock address 2, 123123, other city, TX, 23456',
		mail: 'mock address 2',
		city: 'other city',
		state: 'TX',
		zip: '23456',
	},
	{
		value: 'mock address 3, 123123123, another city, WA, 34567',
		description: 'mock address 3, 123123123, another city, WA, 34567',
		mail: 'mock address 3',
		city: 'another city',
		state: 'WA',
		zip: '34567',
	},
];
